import { AnchorHTMLAttributes } from "react";
import { useAppState } from "../../../common/appState";
import { getExternalLinkAttributes } from "./externalLink";

export function ATargetBlank(
    props: AnchorHTMLAttributes<HTMLAnchorElement> & { nofollow?: boolean }
) {
    const [user] = useAppState("user");
    const { nofollow = false, children, href, rel: _rel, ...rest } = props;
    const linkAttributes = getExternalLinkAttributes(
        href,
        nofollow,
        user?.userId,
        _rel
    );

    return (
        <a target="_blank" {...linkAttributes} {...rest}>
            {children}
        </a>
    );
}
